import { FC } from 'react';

import { Box, Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import { ISubmission } from '../../../interfaces/submission';
import { useAuthStore } from '../../../stores/auth';
import { SubmissionStatusChip } from '../../molecules/SubmissionStatusChip';
import { UserTag } from '../../molecules/UserTag';

export const SubmissionCard: FC<ISubmission> = ({ _id, title, summary, status }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useAuthStore((store) => store.user);

  return (
    <Card
      sx={{
        boxShadow: 10,
        display: 'flex',
        background: 'none',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        cursor: 'pointer',
      }}
      onClick={() => navigate(`/my-proposals/${_id}`)}
    >
      <Box sx={{ p: 3, width: '100%', background: theme.palette.background.paper }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 1.5 }}>
          <UserTag publicAddress={user?.publicAddress} />
          {status && <SubmissionStatusChip status={status} />}
        </Box>

        <Typography variant={'h6'}>{title}</Typography>
        <Typography
          sx={{ my: 2, display: '-webkit-box', WebkitLineClamp: 4, overflow: 'hidden', WebkitBoxOrient: 'vertical' }}
          color="text.secondary"
        >
          {summary}
        </Typography>
      </Box>
    </Card>
  );
};
